<template>
  <button class="btn" style="  user-select: none;">
    <slot />
  </button>
</template>

<script>
export default {
  name: "Button",
};
</script>

<style scoped>
.btn-continuar {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #000000;
  border-radius: 18px;
  opacity: 1;
  width: 100px;
  height: 32px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
}

.btn-continuar:hover {
  background: black 0% 0% no-repeat padding-box;
  color: white;
}

.btn-agregar {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #6E44DA;
  color: #6E44DA;
  border-radius: 18px;
  opacity: 1;
  width: 100px;
  height: 32px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
}

.btn-agregar:hover {
  background: #6E44DA 0% 0% no-repeat padding-box;
  color: white;
}

.btn-buscar {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid black;
  color: black;
  border-radius: 18px;
  opacity: 1;
  width: 100px;
  height: 32px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 5px;
}

.btn-buscar:hover {
  background: black 0% 0% no-repeat padding-box;
  color: white;
}

.btn-editar {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #000000;
  border-radius: 18px;
  opacity: 1;
  width: 28px;
  height: 28px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 5px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px !important;
}

.btn-editar:hover {
  background: black 0% 0% no-repeat padding-box;
  color: white;
}

.btn-agregar-cobaes {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid black;
  color: black;
  border-radius: 18px;
  opacity: 1;
  width: 28px;
  height: 28px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 5px;
}

.btn-agregar-cobaes:hover {
  background: black 0% 0% no-repeat padding-box;
  color: white;
}

.btn-eliminar {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #CB0809;
  color: #CB0809;
  border-radius: 18px;
  opacity: 1;
  width: 28px;
  height: 28px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 5px;
}

.btn-eliminar:hover {
  background: #CB0809 0% 0% no-repeat padding-box;
  color: white;
}

.btn-regresar {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #000000;
  border-radius: 18px;
  opacity: 1;
  width: 110px;
  height: 32px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
}

.btn-regresar:hover {
  background: black 0% 0% no-repeat padding-box;
  color: white;
}

.btn-atras {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #CB0809;
  color: #CB0809;
  border-radius: 18px;
  opacity: 1;
  width: 28px;
  height: 28px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 5px;
}

.btn-atras:hover {
  background: #CB0809 0% 0% no-repeat padding-box;
  color: white;
}

.btn-descargar-excel {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #0f7d21;
  color: #0f7d21;
  border-radius: 18px;
  opacity: 1;
  width: 28px;
  height: 28px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 5px;
}

.btn-descargar-excel:hover {
  background: #0f7d21 0% 0% no-repeat padding-box;
  color: white;
}

.btn-guardar {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #237a1b;
  color: #237a1b;
  border-radius: 18px;
  opacity: 1;
  width: 110px;
  height: 32px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
}

.btn-guardar:hover {
  background: #237a1b 0% 0% no-repeat padding-box;
  color: white;
}

.btn-guardar-cotizacion {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #237a1b;
  color: #237a1b;
  border-radius: 18px;
  opacity: 1;
  width: 80px;
  height: 28px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
}

.btn-cancelar-cotizacion {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #b40000;
  color: #b40000;
  border-radius: 18px;
  opacity: 1;
  width: 80px;
  height: 28px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
}

.btn-guardar-cotizacion:hover {
  background: #237a1b 0% 0% no-repeat padding-box;
  color: white;
}


.btn-confirmar-eliminar {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #CB0809;
  color: #CB0809;
  border-radius: 18px;
  opacity: 1;
  width: 110px;
  height: 32px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 5px;
}

.btn-confirmar-eliminar:hover {
  background: #CB0809 0% 0% no-repeat padding-box;
  color: white;
}

.btn-reset {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #000000;
  border-radius: 18px;
  opacity: 1;
  width: 28px;
  height: 28px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 5px;
}

.btn-reset:hover {
  background: black 0% 0% no-repeat padding-box;
  color: white;
}

.btn-GenNewPass {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #000000;
  border-radius: 10px;
  opacity: 1;
  width: 100%;
  height: 32px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 0px 0px 5px;
}

.btn-GenNewPass:hover {
  background: black 0% 0% no-repeat padding-box;
  color: white;
}

.btn-cerrar-sesion-kiosko {
  background-color: #691c32;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 20px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s;
  width: 200px;
  height: 50px;
}

.btn-cerrar-sesion-kiosko:hover {
  background-color: #9b3b55;
}

.btn-pagarSelecc {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #237a1b;
  color: #237a1b;
  border-radius: 18px;
  opacity: 1;
  width: 160px;
  height: 32px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin-left: 20px;
}

.btn-pagarSelecc:hover {
  background: #237a1b 0% 0% no-repeat padding-box;
  color: white;
}

.btn-subir-archivo {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #691c32;
  color: #691c32;
  border-radius: 18px;
  opacity: 1;
  width: 130px;
  height: 32px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  justify-content: space-evenly;
  display: flex;
  align-items: center;
  font-weight: 700;
}

.btn-subir-archivo:hover {
  background: #691c32 0% 0% no-repeat padding-box;
  color: white;
}

.btn-ver {
  background-color: #4a90e2;
  color: white;
}

.btn-ver:hover {
  background-color: #357ABD;
}


.btn-ubicacion {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #000000;
  border-radius: 18px;
  opacity: 1;
  width: 28px;
  height: 28px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 5px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px !important;
}

.btn-ubicacion:hover {
  background: black 0% 0% no-repeat padding-box;
  color: white;
}

.btn-enviar {
  background-color: #6E44DA;
  border: none;
  color: white;
  padding: 8px 15px;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.chat-input button:hover {
  background-color: #0056b3;
}


.btn-finalizar {
  background-color: black;
  border: none;
  color: white;
  padding: 8px 15px;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-agregar-comunicado {
  margin-top: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  background-color: black;
  color: white;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  width: -moz-fit-content;
  border: none;
}

.btn-agregar-comunicado:hover {
  background-color: #6E44DA;
}


.btn-conf-cuota-mensual {
  background: white 0% 0% no-repeat padding-box;
  border: 1px solid #237a1b;
  color: #237a1b;
  border-radius: 18px;
  opacity: 1;
  width: 70px;
  height: 30px;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;
  font-weight: 700;
  margin: 0px 5px;
}

.btn-conf-cuota-mensual:hover {
  background: #237a1b 0% 0% no-repeat padding-box;
  color: white;
}
</style>